import React from 'react';
import { Button } from '@/components/molecules/buttons/button';
import { Label } from '@/components/atoms/texts/label';
import { useTranslation } from 'react-i18next';

const MessageBubble = ({ message, isOwn, isUnread, onEdit, onDelete, onUnreadMessageClick }) => {
    const [t] = useTranslation('global');
    const isDeleted = Boolean(message?.deletedAt);

    const bubbleStateClass = isDeleted
        ? 'border border-primary/10 bg-white text-greyStrong italic'
        : isOwn
            ? 'bg-primary text-white'
            : isUnread
                ? 'border border-secondary/50 bg-secondary/10 text-night'
                : 'border border-primary/10 bg-white text-night';

    const bubbleCornerClass = isOwn
        ? 'rounded-[14px] rounded-br-[var(--cornerSmall)]'
        : 'rounded-[14px] rounded-bl-[var(--cornerSmall)]';

    const isUnreadInboundMessage = isUnread && !isOwn && !isDeleted;
    const senderInitials = String(message?.senderName || '?')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('') || '?';
    const timeStr = new Date(message.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return (
        <div className={`flex ${isOwn ? 'justify-end' : 'justify-start gap-1.5'}`}>
            {!isOwn && (
                <div
                    className="h-6 w-6 self-end rounded-[7px] bg-secondary text-[9px] font-bold text-primary flex items-center justify-center"
                    aria-hidden="true"
                >
                    <Label className="text-[9px] font-bold text-primary">{senderInitials}</Label>
                </div>
            )}

            <div
                className={`max-w-[76%] ${isOwn ? 'ml-auto' : ''}`}
                onClick={isUnreadInboundMessage ? onUnreadMessageClick : undefined}
                role={isUnreadInboundMessage ? 'button' : undefined}
                tabIndex={isUnreadInboundMessage ? 0 : undefined}
                onKeyDown={isUnreadInboundMessage ? (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onUnreadMessageClick?.();
                    }
                } : undefined}
            >
                <div className={`px-3 py-2 text-[12px] leading-relaxed whitespace-pre-wrap break-words ${bubbleCornerClass} ${bubbleStateClass} ${isUnreadInboundMessage ? 'cursor-pointer' : ''}`}>
                    {isDeleted
                        ? <Label message="management.onboarding.chat.messageDeleted" />
                        : <Label>{message.content}</Label>}
                </div>

                <div className={`mt-1 flex items-center gap-2 px-0.5 text-[10px] text-primary-hover ${isOwn ? 'justify-end' : ''}`}>
                    {isOwn && message.editable && !isDeleted && (
                        <>
                            <Button
                                style="link"
                                text="management.onboarding.actions.editMessage"
                                showText
                                onClick={onEdit}
                                sizePadding="none"
                            />
                            <Button
                                style="link"
                                text="management.onboarding.actions.deleteMessage"
                                showText
                                onClick={onDelete}
                                sizePadding="none"
                            />
                        </>
                    )}

                    <Label className="text-[10px] text-primary-hover">{timeStr}</Label>
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
